// src/components/store/sections/gallery/GalleryV97BentomosaicCrimsonRose.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV97BentomosaicCrimsonRose(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={97}
      archKey="bento_mosaic"
      archLabel="Bento Mosaic Lookbook"
      palName="CrimsonRose"
      grad="from-rose-500 via-pink-600 to-red-600"
      lightBg="bg-rose-50"
      textCol="text-rose-700"
      borderCol="border-rose-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f43f5e"
      {...props}
    />
  );
}
